var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['sw-icon', { 'sw-icon--bottom': _vm.bottomAlign, 'sw-icon--block': _vm.asBlock }],style:(_vm.styles)},[_c('span',{class:['sw-icon__inner', 'sw-font-icon', ("icon-" + _vm.name)],style:(_vm.innerStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }